import gql from 'graphql-tag'

const statsPubblicitaTablePerformanceTipiCampagne = gql`
  query statsPubblicitaTablePerformanceTipiCampagne($mese: Int, $anno: Int!, $tipologiaFiltroRisultati: TipologiaFiltroRisultati, $nazione: String) {
    statsPubblicitaTablePerformanceTipiCampagne(mese: $mese, anno: $anno, tipologiaFiltroRisultati: $tipologiaFiltroRisultati, nazione: $nazione) {
      tipo
      tipoCampagnaId
      costo
      numeroContatti
      numeroAppuntamentiFissati
      numeroProposteAcquisto
      numeroPreliminari
      nazione
    }
  }
`

export default statsPubblicitaTablePerformanceTipiCampagne



// WEBPACK FOOTER //
// ./src/graphql/queries/statsPubblicitaTablePerformanceTipiCampagne.js